import React from 'react';
import { SearchIcon } from 'lucide-react';
import { clinicalQuestions } from '../data/site';
import { SectionCta } from './SectionCta';
const swaps = [{
  from: 'Instead of jumping between documents…',
  to: 'You open the corresponding pathway.'
}, {
  from: 'Instead of trying to remember everything…',
  to: 'You follow the structure.'
}, {
  from: 'Instead of searching from scratch…',
  to: 'You start from the clinical scenario.'
}];
export function NoPdfSection() {
  return <section className="w-full bg-navy px-5 py-14 sm:px-6 sm:py-20" data-id="element-189" data-mp="1l6r8chaf553o">
      <div className="mx-auto max-w-3xl" data-id="element-190" data-mp="1l6hgeo5tcnvc">
        <h2 className="font-serif text-[28px] font-bold leading-[1.12] text-cream sm:text-4xl" data-id="element-191" data-mp="1zw6u1iv3ekci">
          You don’t need another giant PDF.
          <span className="mt-2 block text-gold-light" data-id="element-192" data-mp="1ux2kgr49akln">You need a system that tells you where to look.</span>
        </h2>

        <p className="mt-5 text-[16px] leading-relaxed text-cream/70 sm:text-[17px]" data-id="element-193" data-mp="28u8yk8e1bv4j">
          Imagine having one organized clinical desk where you can quickly locate:
        </p>

        <ul className="mt-6 space-y-2.5" data-id="element-194" data-mp="gr4qv2czxjf0">
          {clinicalQuestions.map(question => <li key={question} className="flex items-start gap-3 rounded-xl bg-white/[0.06] px-4 py-3.5 ring-1 ring-inset ring-white/10" data-id="element-195" data-mp="krf675mohm6j">
              <SearchIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-196" data-mp="uq4d63d1dm80" />
              <span className="font-serif text-[15.5px] font-semibold italic leading-snug text-cream sm:text-[17px]" data-id="element-197" data-mp="zn4p2uwkhj71">
                “{question}”
              </span>
            </li>)}
        </ul>

        <div className="mt-9 grid gap-3 sm:grid-cols-3" data-id="element-198" data-mp="18hspo7r76cpi">
          {swaps.map(swap => <div key={swap.from} className="rounded-xl border border-gold/25 p-4" data-id="element-199" data-mp="1de9el4680v3n">
              <p className="text-[13px] leading-snug text-cream/55" data-id="element-200" data-mp="1ifgop9vu66dh">{swap.from}</p>
              <p className="mt-2 text-[14.5px] font-bold leading-snug text-cream" data-id="element-201" data-mp="1nd8pktegl2tt">{swap.to}</p>
            </div>)}
        </div>

        <SectionCta headline="Stop rebuilding your reasoning from scratch with every patient." label="Yes, I want the Desk" variant="gold" data-id="element-202" data-mp="xqeapmugye2x" />
      </div>
    </section>;
}